export type TypeMask = "cep" | "currency" | "cpf" | "cnpj" | "cpf_cnpj" | "decimal1" | "decimal2" | "decimal3"
    | "date" | "time" | "date_time" | "phone" | "credit_card_expiry" | "credit_card" | "credit_card_cvc";

const cepMask = /^\d{5}-\d{3}$/;
const phoneMask = /^\((\d{2})\)\s(9\d{4}|\d{4})-(\d{4})$/;
const cnpjMask = /^[A-Za-z0-9]{2}\.[A-Za-z0-9]{3}\.[A-Za-z0-9]{3}\/[A-Za-z0-9]{4}-\d{2}$/;
const cpfMask = /^(\d{3}).(\d{3}).(\d{3})-(\d{2})$/;
const dateMask = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const creditCardExpiryMask = /^(\d{2})\/(\d{2})$/;
const creditCardCVCMask = /^(\d{3})$/;
const creditCardMask = /^(\d{4})\s(\d{4})\s(\d{4})\s(\d{4})$/;
const timeMask = /^(\d{2}):(\d{2})$/;
const dateTimeMask = /^(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):(\d{2})$/;

export const isValid = (value: string, typeMask: TypeMask): boolean => {
    switch (typeMask) {
        case "cep":
            return !!value.match(cepMask)
        case "phone":
            return !!value.match(phoneMask);
        case "cnpj":
            return !!value.match(cnpjMask);
        case "cpf":
            return !!value.match(cpfMask);
        case "date":
            return !!value.match(dateMask);
        case "time":
            return !!value.match(timeMask);
        case "date_time":
            return !!value.match(dateTimeMask);
        case "credit_card":
            return !!value.match(creditCardMask);
        case "credit_card_cvc":
            return !!value.match(creditCardCVCMask);
        case "credit_card_expiry":
            return !!value.match(creditCardExpiryMask);
    }
    return false;
}


export const parseCurrency = (value: string): string => {
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d)(\d{2})$/, "$1,$2");
    value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");
    return value
}

export const parseCPF = (value: string): string => {
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/((\d{3}.\d{3}.\d{3}-|\d{3}.\d{3}.\d{3}))(\d{1,})$/, "$1-$3");
    return value
}

export const parseCNPJ = (value: string): string => {
    // Remove tudo que não for letra ou número
    value = value?.replace(/[^a-zA-Z0-9]/g, "");

    // Converte para maiúsculo
    value = value?.toUpperCase();

    // Limita em 14 caracteres
    value = value?.slice(0, 14);

    // Aplica máscara
    value = value?.replace(/^([A-Z0-9]{2})([A-Z0-9])/, "$1.$2");
    value = value?.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3");
    value = value?.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})([A-Z0-9])/, "$1.$2.$3/$4");
    value = value?.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})\.([A-Z0-9]{3})\/([A-Z0-9]{4})([A-Z0-9])/, "$1.$2.$3/$4-$5");

    return value;
};


export const parsePhone = (value: string): string => {
    value = value?.replace(/\D/g, "");
    value = value?.replace(/^0/, "");
    if (value?.length > 10) {
        value = value?.replace(/^(\d\d)(\d{5})(\d{4}).*/, "($1) $2-$3");
    } else if (value?.length > 5) {
        value = value?.replace(/^(\d\d)(\d{4})(\d{0,4}).*/, "($1) $2-$3");
    } else if (value?.length > 2) {
        value = value?.replace(/^(\d\d)(\d{0,5})/, "($1) $2");
    } else if (value?.length > 1) {
        value = value?.replace(/^(\d*)/, "($1");
    }

    return value;
}

export const parseCEP = (value: string): string  => {
    value = value.replace(/\D/g, "")?.slice(0, 8);
    value = value.replace(/^(\d{5})(\d)/, "$1-$2");
    return value;
}

export const cep = (e: any) => {
    e.target.maxLength = 9;
    let value = e.target.value;
    value = value.replace(/\D/g, "")?.slice(0, 8);
    value = value.replace(/^(\d{5})(\d)/, "$1-$2");
    e.target.value = value;
    return e;
}

export const currency = (e: any) => {
    let value = e.target.value;
    value = parseCurrency(value)

    e.target.value = value;
    return e;
}

export const decimal1 = (e: any) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d)(\d{1})$/, "$1,$2");
    value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

    e.target.value = value;
    return e;
}

export const decimal2 = (e: any) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d)(\d{2})$/, "$1,$2");
    value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

    e.target.value = value;
    return e;

}

export const decimal3 = (e: any) => {
    let value = e.target.value;
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d)(\d{3})$/, "$1,$2");
    value = value.replace(/(?=(\d{3})+(\D))\B/g, ".");

    e.target.value = value;
    return e;
}

export const cpf = (e: any) => {
    e.target.maxLength = 14;
    let value = e.target.value;
    if (!value.match(cpfMask)) {
        value = parseCPF(value)
        e.target.value = value;
    }
    return e;
}

export const cnpj = (e: any) => {
    e.target.maxLength = 18;
    let value = e.target.value;
    if (!value.match(cnpjMask)) {
        value = parseCNPJ(value)
        e.target.value = value;
    }
    return e;
}

export const cpfCnpj = (e: any) => {
    e.target.maxLength = 18
    let value = e.target.value?.substring(0, e.target.maxLength);
    const valLength = value.length;
    const withLetters = /[a-zA-Z]/.test(value);

    if (valLength <= 14 && !withLetters && !value.match(cpfMask)) {
        value = parseCPF(value)
        e.target.value = value;
    } else if (valLength >= 15 && !value.match(cnpjMask)) {
        value = parseCNPJ(value);
        e.target.value = value;
    }

    return e;
}

export const date = (e: any) => {
    e.target.maxLength = 10;
    let value = e.target.value;
    if (!value.match(dateMask)) {
        value = value.replace(/\D/g, "");
        value = value.replace(/(\d{2})(\d)/, "$1/$2");
        value = value.replace(/(\d{2})(\d)/, "$1/$2");
        value = value.replace(/(\d{4})(\d)/, "$1/$2");
        e.target.value = value;
    }
    return e;
}

export const creditCardExpiry = (e: any) => {
    e.target.maxLength = 5;
    let value = e.target.value;
    if (!value.match(creditCardExpiryMask)) {
        value = value?.replace(/\D/g, "");
        value = value?.replace(/(\d{2})(\d)/, "$1/$2");
        e.target.value = value;
    }
    return e;
}

export const creditCardCVC = (e: any) => {
    e.target.maxLength = 3;
    let value = e.target.value;
    if (!value.match(creditCardCVCMask)) {
        value = value?.replace(/\D/g, "");
        value = value?.replace(/(\d{3})/, "$1");
        e.target.value = value;
    }
    return e;
}

export const creditCard = (e: any) => {
    e.target.maxLength = 19;
    let value = e.target.value;
    if (!value.match(creditCardMask)) {
        value = value?.replace(/\D/g, "");
        value = value.replace(/(\d{4})(\d)/, "$1 $2");
        value = value.replace(/(\d{4})(\d)/, "$1 $2");
        value = value.replace(/(\d{4})(\d)/, "$1 $2");
        value = value.replace(/(\d{4})(\d)/, "$1 $2");
        e.target.value = value;
    }
    return e;
}


export const time = (e: any) => {
    e.target.maxLength = 5;
    let value = e.target.value;
    if (!value.match(timeMask)) {
        value = value.replace(/\D/g, "");
        value = value.replace(/(\d{2})(\d)/, "$1:$2");
        e.target.value = value;
    }
    return e;
}

export const dateTime = (e: any) => {
    e.target.maxLength = 16;
    let value = e.target.value;
    if (!value.match(dateTimeMask)) {
        value = value.replace(/\D/g, "");
        value = value.replace(/(\d{2})(\d)/, "$1/$2");
        value = value.replace(/(\d{2})(\d)/, "$1/$2");
        value = value.replace(/(\/\d{4})(\d)/, "$1 $2");
        value = value.replace(/(\s\d{2})(\d)/, "$1:$2");

        e.target.value = value;
    }
    return e;
}
export const phone = (e: any) => {
    e.target.maxLength = 15;
    let value = e.target?.value;
    if (!value?.match(phoneMask) && value.length > 2) {
        value = parsePhone(value)

        e.target.value = value;
    }
    return e;
} 

export const cnpjCpf = (text: string): string => {
    if (String(text).length === 11) {
        return (
            text.substring(0, 3) +
            "." +
            text.substring(3, 6) +
            "." +
            text.substring(6, 9) +
            "-" +
            text.substring(9, 11)
        );
    }

    if (String(text).length === 14) {
        return (
            text.substring(0, 2) +
            "." +
            text.substring(2, 5) +
            "." +
            text.substring(5, 8) +
            "/" +
            text.substring(8, 12) +
            "-" +
            text.substring(12, 14)
        );
    }

    return text;
}